import moment from 'moment'

export default {
    methods: {

        async getFiltrar() {
            await this.getDataGet({ route: 'get_liquidacion', data: { others: [] } })
                // frontend await this.searchGetIdb({tabla:'afiliacion_registro'})
        },
        async watchAfiliado() {
            let getBackend = await this.getData({ route: 'ficha_afiliado_get', data: this.searchSw.value })
            const await1 = this.updateDataForm({ state: 'datos_afiliado', data: getBackend.datos_afiliado })
            const await2 = this.updateDataForm({ state: 'info_afiliacion', data: getBackend.info_afiliacion })
            await await1
            await await2
            const await3 = this.updateDataForm({ state: 'info_liquidacion/name', data: getBackend.datos_afiliado.name })
            const await4 = this.updateDataForm({ state: 'info_liquidacion/id_list_tipo', data: getBackend.datos_afiliado.id_list_tipo })
            const await5 = this.updateDataForm({ state: 'info_liquidacion/documento', data: getBackend.datos_afiliado.documento })
            const await6 = this.updateDataForm({ state: 'info_liquidacion/cargo', data: getBackend.info_afiliacion.cargo })
            const await7 = this.updateDataForm({ state: 'info_liquidacion/salario', data: getBackend.info_afiliacion.salariobase })
            const await8 = this.updateDataForm({ state: 'info_liquidacion/id_datos_afiliado', data: getBackend.datos_afiliado.id })
            const await9 = this.updateDataForm({ state: 'info_liquidacion/id_datos_razon', data: getBackend.info_afiliacion.id_datos_razon })
            await await3
            await await4
            await await5
            await await6
            await await7
            await await8
            await await9

        },
        limpiarAfiliado() {
            this.searchSw.value = ''
            this.resetDataForm()
            this.updateDataForm({ state: 'info_liquidacion/fecha', data: this.fecha().fecha.minHoy })
        },
        changeValues() {
            let fechaini = this.dataForm[this.namePath].info_liquidacion.fechaini
            let fechafin = this.dataForm[this.namePath].info_liquidacion.fechafin
            var meses = moment(fechafin).diff(moment(fechaini), 'months') * 30
            var mesini = parseInt(moment(fechaini).format('MM'))
            var diaini = parseInt(moment(fechaini).format('DD'))
            var mesfin = parseInt(moment(fechafin).format('MM'))
            var diafin = parseInt(moment(fechafin).format('DD'))
            var dias = diafin + meses

            if (meses === 0) {
                if (mesini != mesfin) {
                    dias = moment(fechafin).diff(moment(fechaini), 'days')
                } else {
                    dias = moment(fechafin).diff(moment(fechaini), 'days') + 1
                }
            } else {
                dias = (dias - 30) + (31 - diaini)
            }

            let diasprimer = 0
            let diassegundo = 0
            if (6 - mesini >= 0) {
                diasprimer = ((6 - mesini + 1) * 30) + 1 - diaini
                if (mesfin < 7) {
                    diasprimer = dias > diasprimer ? diasprimer : dias
                    dias = dias > diasprimer ? diasprimer : dias
                    diassegundo = 0
                } else {
                    diassegundo = ((mesfin - 6) * 30) - (30 - diafin)
                    dias = diasprimer + diassegundo
                }
            } else {
                diasprimer = 0
                diassegundo = dias
            }
            if (dias > 360) {
                dias = 360
            }
            for (let i = 0; i < this.dataForm[this.namePath].liquidacion_devengados.length; i++) {
                let value = 0
                switch (this.dataForm[this.namePath].liquidacion_devengados[i].predeterminado) {
                    case 'cesantias':
                        value = (this.dataForm[this.namePath].info_liquidacion.salario + this.dataForm[this.namePath].info_liquidacion.transporte) * dias / 360
                        this.updateDataForm({ state: 'liquidacion_devengados/' + i + '/valor', data: value })
                        break
                    case 'intereses':
                        value = (this.dataForm[this.namePath].info_liquidacion.salario + this.dataForm[this.namePath].info_liquidacion.transporte) * dias / 360 * (0.12 * dias / 360)
                        this.updateDataForm({ state: 'liquidacion_devengados/' + i + '/valor', data: value })
                        break
                    case 'primerprima':
                        value = (this.dataForm[this.namePath].info_liquidacion.salario + this.dataForm[this.namePath].info_liquidacion.transporte) * diasprimer / 360
                        this.updateDataForm({ state: 'liquidacion_devengados/' + i + '/valor', data: value })
                        break
                    case 'segundaprima':
                        value = (this.dataForm[this.namePath].info_liquidacion.salario + this.dataForm[this.namePath].info_liquidacion.transporte) * diassegundo / 360
                        this.updateDataForm({ state: 'liquidacion_devengados/' + i + '/valor', data: value })
                        break
                    case 'vacaciones':
                        value = this.dataForm[this.namePath].info_liquidacion.salario * dias / 720
                        this.updateDataForm({ state: 'liquidacion_devengados/' + i + '/valor', data: value })
                        break
                }
            }
            this.ultimoFin = fechafin
        }
    },
}